import styles from "./Spacer.module.scss"

export default function Spacer(props) {
  return (
    <div className={`${styles.spacer} ${props.className}`}>
      {props.children}
    </div>
  )
}
